import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { BookingService } from '../../shared/services/booking.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-edit-booking-po-number',
    templateUrl: './edit-booking-po-number-dialog.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class EditBookingPoNumberDialogComponent {
  poFc = new FormControl();

  constructor(
    private dialogRef: MatDialogRef<EditBookingPoNumberDialogComponent>,
    private bookingService: BookingService,
    @Inject(MAT_DIALOG_DATA)
    public data: { bookingId: number; purchase_order: string }
  ) {
    this.poFc.setValue(data.purchase_order);
  }

  save() {
    this.bookingService
      .update(this.data.bookingId, {
        purchase_order: this.poFc.value
      })
      .subscribe(() => {
        this.dialogRef.close({ purchase_order: this.poFc.value });
      });
  }
}
